module.exports = __webpack_public_path__ + "static/media/toggle-off.4ea7926e.svg";